export { CellContent, SubTitle } from "../styles/Cell";
